export default __webpack_public_path__ + "src/_images/lifesaferiaLogo.png";